import { setupI18n } from "@lingui/core";
import {
	sentryGlobalFunctionMiddleware,
	sentryGlobalRequestMiddleware,
} from "@sentry/tanstackstart-react";
import { type AnyRequestMiddleware, createMiddleware, createStart } from "@tanstack/react-start";
import { dynamicActivate } from "~/modules/lingui/i18n";
import { getLocaleFromRequest } from "~/modules/lingui/i18n.server";

const documentProfilingMiddleware = (): AnyRequestMiddleware => {
	return createMiddleware().server(async ({ next }) => {
		const result = await next();

		result.response.headers.set("Document-Policy", "js-profiling");

		return result;
	});
};

const linguiMiddleware = (): AnyRequestMiddleware => {
	return createMiddleware().server(async ({ request, next }) => {
		const { locale, headers } = getLocaleFromRequest(request);

		const i18n = setupI18n();
		await dynamicActivate(i18n, locale);

		const result = await next({
			context: {
				locale,
				i18n,
			},
		});

		if (headers) {
			headers.forEach(({ key, value }) => {
				result.response.headers.append(key, value);
			});
		}

		return result;
	});
};

export const startInstance = createStart(() => {
	return {
		requestMiddleware: [
			sentryGlobalRequestMiddleware,
			documentProfilingMiddleware(),
			linguiMiddleware(),
		],
		functionMiddleware: [sentryGlobalFunctionMiddleware],
	};
});
